import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import { useCallback, useState } from 'react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { validateCpmBannerPhraseBid } from '../../../service/PhraseMoneyCell/PhraseMoneyCell';
import { TestBem } from '../../../service/TestBem';
import { ValidationErrorData } from '../../../typings/common';
import { CurrencyLimitData } from '../../../typings/constants';
import { CurrencyCode } from '../../../typings/graphql-grid';
import { PhrasesSelectorRateEditor } from '../PhrasesSelectorRateEditor/PhrasesSelectorRateEditor';

import './PhrasesSelectorFooter.css';
import * as keyset from './PhrasesSelectorFooter.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'phrases-selector-footer';

export interface PhrasesSelectorFooterProps {
    hasPhrases: boolean;
    isPriceRateEnabled: boolean;
    workCurrency: CurrencyCode;
    priceRate?: number;
    priceRateLimit: CurrencyLimitData;
    onSubmit: () => void;
    onPriceRateChange: (rate: number) => void;
}

export const PhrasesSelectorFooter = React.memo(
    ({
        hasPhrases,
        isPriceRateEnabled,
        workCurrency,
        priceRateLimit,
        priceRate,
        onSubmit,
        onPriceRateChange
    }: PhrasesSelectorFooterProps) => {
        const [error, setError] = useState<ValidationErrorData | undefined>(undefined);

        const onRawRateChange = useCallback(rawRate => {
            if (!priceRateLimit) {
                setError(undefined);
                return;
            }

            const clientValidationResult = validateCpmBannerPhraseBid(rawRate, priceRateLimit, workCurrency);
            const rateError = clientValidationResult.errors ? clientValidationResult.errors[0] : undefined;

            setError(rateError);
        }, []);

        const isPriceValid = !Boolean(error) && Boolean(priceRate);
        const isSaveDisabled = !hasPhrases || (isPriceRateEnabled && !isPriceValid);

        return (
            <footer className={Bem.cls(BLOCK)}>
                <Button
                    cls={TestBem.cls(BLOCK, 'apply-btn')}
                    disabled={isSaveDisabled}
                    theme="action"
                    view="default"
                    tone="default"
                    size="n"
                    text={i18n('add')}
                    onClick={onSubmit}
                />
                {isPriceRateEnabled && (
                    <PhrasesSelectorRateEditor
                        workCurrency={workCurrency}
                        rateLimit={priceRateLimit}
                        rate={priceRate}
                        error={error}
                        onRawRateChange={onRawRateChange}
                        onRateChange={onPriceRateChange}
                    />
                )}
            </footer>
        );
    }
);
